<template>
  <div class="">
    <p>تعداد ایتم در صفحه</p>
    <b-form-input
        dir="ltr"
        @keypress.enter.prevent="changePerPage"
        v-model="per_page"
    ></b-form-input>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      per_page: 12,
    }
  },
  methods: {
    changePerPage() {
      if (this.per_page  > 0) {
        let page = 1
        this.$store.commit('Product/setFilters', {key: 'per_page', value: this.per_page})
        this.$store.dispatch("Product/setDashboardProducts", page);
      }
    }
  }
}
</script>

<style scoped>

</style>